import { Helmet } from "react-helmet-async";
import ogBanner from "../images/og-banner.jpg"; // ✅ Open Graph banner image
import favicon from "../images/favicon.jpg";    // ✅ Import your favicon (place inside src/images/)

export default function DefaultsMeta({
  title = "Yours Energy Solutions | Solar Rooftop & Clean Energy Experts in Northeast India",
  description = "Yours Energy Solutions provides premium solar rooftop systems, Adani solar panels, and end-to-end installation & maintenance services across India — helping homes and businesses save energy and costs sustainably.",
  keywords = "solar rooftop, solar panel installation, Sivasagar , Sibsagar , Jorhat , Dibrugarh , Guwahati solar maintenance India, Yours Energy Solutions, clean energy, green power, renewable energy company, solar energy provider, sustainable energy, residential solar systems, commercial solar panels, solar street lights, Patna solar company, energy independence, AMC services solar",
  canonical = typeof window !== "undefined"
    ? window.location.href
    : "https://yoursenergies.com",
}) {
  const baseUrl =
    typeof window !== "undefined"
      ? window.location.origin
      : "https://yoursenergies.com";

  const imageUrl = `${baseUrl}${ogBanner}`;
  const faviconUrl = `${baseUrl}${favicon}`;

  return (
    <Helmet>
      {/* ✅ Basic SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* ✅ Favicon */}
      <link rel="icon" type="image/png" href={faviconUrl} />
      <link rel="apple-touch-icon" href={faviconUrl} />
      <meta name="theme-color" content="#0D47A1" />

      {/* ✅ Open Graph (for Facebook, LinkedIn, WhatsApp) */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="Yours Energy Solutions" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content="en_IN" />

      {/* ✅ Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* ✅ Additional SEO metadata */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Yours Energy Solutions" />
      <meta name="geo.region" content="IN-BR" />
      <meta name="geo.placename" content="Patna" />
      <meta name="geo.position" content="25.5941;85.1376" />
      <meta name="ICBM" content="25.5941, 85.1376" />
    </Helmet>
  );
}
